// extracted by mini-css-extract-plugin
export default {"wine_btn":"SubToNewsletter_wine_btn__ROTB4"};